import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import CustomSidePanel from './common/CustomSidePanel';
import SignatureComponent from './common/SignatureComponent';
import ActionButton from './common/Action Buttons/ActionButton';
import ActionButton2 from './common/Action Buttons/ActionButton2';
import DocumentViewerComponent from './DocumentViewerComponent';
import {createContract, viewContract} from '../api/network/contractsService';
import {addNotification} from '../redux/actions/NotificationActions';

const ContainerWrapper = styled.div`
    overflow:hidden;
`;

const PanelContentWrapper = styled.div`
    display: flex;
    width: fit-content;
    //max-height: 100vh;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
`;

const SignatureComponentWrapper = styled.div`
    margin: 10px 0;
`;

const SignatureLabel = styled.div`
    margin: 8px 8px;
    /* text-base/Regular */
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/600 */
    color: var(--color-gray-600);
`;

const ActionButtonsWrapper = styled.div`
    display: flex;    
    flex: 0.8;
    > * {
      margin: 8px;
    }
`;

/**
 * Container component that handles the logic for showing document and handling signing container.
 *
 * @param props
 * @return {*}
 * @constructor
 */
function DocumentSignContainer(props) {
    const {
        contract = {},
        showPanel = false,
        onPanelClose,
        documentKey = '',
        documentParams = {},
        signatureKey = '',
        onDocumentSign,
        addNotification,
    } = props;
    const [signatureRef, setSignatureRef] = useState();
    const [isLoading, setLoading] = useState(false);
    const [filename, setFileName] = useState('');
    const [canSubmitSignature, setCanSubmitSignature] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line no-use-before-define
        getDocumentUrl();
    }, [documentKey, documentParams]);

    const onSignatureSave = async e => {
        const {disabled} = e.target;

        if (disabled) return;

        const params = {
            key: documentKey,
            args: {
                ...documentParams,
                [signatureKey]: signatureRef?.toDataURL()
            }
        };

        try {
            // creating a new contract with signed user signature on the business customer service.
            const newContractDocument = await createContract(params);

            // get document id for new signed contract
            const documentId = newContractDocument?.headers['custom-document-id'];
            onDocumentSign(documentId);

            getDocumentUrl();
        } catch (error) {
            console.error('Failed to sign document', error);
            addNotification('Failed to sign document.', 'error');
        }
    };

    const getDocumentUrl = () => {
        const params = {
            key: documentKey,
            args: {
                ...documentParams,
                [signatureKey]: signatureRef?.toDataURL()
            }
        };

        setLoading(true);
        viewContract(params)
            .then(data => {
                setFileName(data?.data?.url);
            })
            .catch(error => {
                // TODO handle error
                console.error(`Failed to get document url for ${documentKey}`, error);
            })
            .finally(_ => {
                setLoading(false);
            });
    };

    return (
        <ContainerWrapper>
            <CustomSidePanel open={showPanel} onDrawerClose={onPanelClose}>
                <PanelContentWrapper>
                    {/*Commit Letter*/}

                    <div style={{flex: 1}}>
                        {
                            filename &&
                            <DocumentViewerComponent filename={filename} width="600px" height="100%"/>
                        }
                    </div>

                    {/*Signature Component*/}
                    <SignatureComponentWrapper>
                        <SignatureLabel> Signature </SignatureLabel>

                        <SignatureComponent
                            setRef={setSignatureRef}
                            onSignatureBegin={() => {
                                setCanSubmitSignature(false);
                            }}
                            onSignatureEnd={() => {
                                getDocumentUrl();
                                setCanSubmitSignature(true);
                            }}
                        />

                        <ActionButtonsWrapper>
                            <ActionButton
                                onClick={onSignatureSave}
                                disabled={!canSubmitSignature || isLoading}
                            >
                                Sign
                            </ActionButton>
                            <ActionButton2 onClick={onPanelClose}>Cancel</ActionButton2>
                        </ActionButtonsWrapper>
                    </SignatureComponentWrapper>

                </PanelContentWrapper>
            </CustomSidePanel>
        </ContainerWrapper>
    );
}

DocumentSignContainer.propTypes = {
    contract: PropTypes.object,
    showPanel: PropTypes.bool,
    onPanelClose: PropTypes.func,
    documentParams: PropTypes.object.isRequired,
    documentKey: PropTypes.string.isRequired,
    signatureKey: PropTypes.string.isRequired,
    onDocumentSign: PropTypes.func.isRequired,
    addNotification: PropTypes.func,
};

DocumentSignContainer.defaultProps = {contract: {}};

const mapDispatchToProps = {addNotification};

export default connect(null, mapDispatchToProps)(DocumentSignContainer);
